
















import Vue from 'vue';
import { mapGetters } from 'vuex';

import NavigationDrawerUser from './user.vue';
import NavigationDrawerTabs from './tabs.vue';
import NavigationDrawerMyProfileButton from './my-profile-button.vue';

export default Vue.extend({
  name: 'NavigationDrawer',

  components: {
    NavigationDrawerUser,
    NavigationDrawerTabs,
    NavigationDrawerMyProfileButton,
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
      'isNavBarOpen',
    ]),

    isOpen() {
      return this.isNavBarOpen
        || (this.$route.name !== 'Landing'
        && this.$route.name !== 'Login'
        && this.$route.name !== 'Logout'
        && this.getUser !== null);
    },
  },
});
